<template>
  <div class="admin-management">
    <!-- 用戶管理的內容 -->
    <h1>AdminDashboard</h1>
  </div>
</template>

<script>
export default {
  name: "AdminDashboard",
};
</script>